module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTStd-Md.84ee62cb.woff";